export default __webpack_public_path__ + "static/media/4-2_image20@2x.5bcb9179.png";